
$(document).ready(function(){

   if (window.matchMedia("(max-width: 1279px)").matches) {  


        $('.js-toggleMenu').on('click',function(e){
            e.preventDefault();
            $(this).toggleClass('is-open');
            $('body').toggleClass('nav-expanded');

            if($('body').not('.nav-expanded')){
                $('.primaryNav').removeClass('translateOut');
                $('.submenu').removeClass('translateIn');
            }
        });

        $('.has-submenu > a').on('click', function(event){
            event.preventDefault();
            var selectedItem = $(this);
            selectedItem.next('ul').addClass('translateIn');
            $('.primaryNav').addClass('translateOut');
        });

       $('.js-backMenu').on('click', function(event){
            event.preventDefault();
            var selectedItem = $(this);
            $('.primaryNav').removeClass('translateOut');

            setTimeout(function(){
                selectedItem.parent().parent('ul').removeClass('translateIn');
            }, 300);
        });

        //Sottomenu
        /*  $('.has-submenu > a').on('click',function(event){
            event.preventDefault();
            $(this).siblings('.submenu').slideToggle('slow');
            $(this).parent().toggleClass('is-selected');
        }); */

    }


    // Sottomenu desktop
    if (window.matchMedia("(min-width: 1280px)").matches){

        $('.has-submenu > a').on('click', function(event){
            event.preventDefault();
             
            var selectedItem = $(this).parent('.has-submenu');

            if(!$(selectedItem).hasClass('is-selected')){
                $('.has-submenu').removeClass('is-selected').children('.submenu').removeClass('is-open');
                selectedItem.addClass('is-selected').children('.submenu').addClass('is-open');
            }
            
            else{
                selectedItem.removeClass('is-selected').children('.submenu').removeClass('is-open');
            }
        });
       
  
      $(document).click(function (e) {
        //check if the clicked area is dropDown or not
          if ($('.has-submenu').has(e.target).length === 0) {
                $('.has-submenu').removeClass('is-selected').children('.submenu').removeClass('is-open');
            }
          
          if ($('.js-dropdown,.js-dropdown > ul').has(e.target).length === 0) {
                $('.js-dropdown > ul').hide();
            }
           
        })
    }

    // Larghezza progress bar progetti landing 
    $("div[data-progress]").each(function(){
        $(this).css({
            width: $(this).attr('data-progress')
        });
    });

   


    // Form contatti prefooter
    /*
    $('.message').hide();
    $('input[type="radio"][name="richiesta"]').click(function() {
        if ($('#altro').is(':checked')) {
            $('.message').slideDown();
        } else if (!($('#altro').is(':checked'))) {
            $('.message').slideUp();
        }
    })
    */

    // Interazioni form Contatti
    $(document).on('click', 'input[type="radio"][name="richiesta"]', function(e) {
        $('[name="richiesta_val"]').val($(this).val()).blur();
    });
    $(document).on('change', 'input[type="radio"][name="richiesta"]', function(e) {
        if ($('#richiesta_altro').is(':checked')) {
            $('#richiesta_messaggio').val('').parents('.form-field').slideDown();
        }
        else {
            $('#richiesta_messaggio').val('(nessun messaggio)').parents('.form-field').slideUp();
        }
    });

    //
    // Modali popup privacy forms - INIZIO
    //

    // Form Contatto e Prenota
    //
    // Logica di selezione: all'inizio il cb e' disabilitato e devo per forza aprire la modale e accettare da li'; dopodiche' posso agire direttamente sul cb
    //
    var privacyAccepted = false;
    $('#privacy').click(function(e) {
        if (! privacyAccepted) {
            e.preventDefault();
            $('[popovertarget="fullModalPrivacy"]:not([popovertargetaction])').click();
        }
    });
    $('#fullModalPrivacyAccept').click(function(e) {
        e.preventDefault();
        privacyAccepted = true;
        $('#privacy').prop('checked', true).change();
        $('[popovertarget="fullModalPrivacy"][popovertargetaction="hide"]').click();
    });
    //
    // Rimozione info scroll
    // 
    if ($('#fullModalPrivacyInfoScroll').length && $('#fullModalPrivacyAccept').length) {
        var infoScroll = document.querySelector('#fullModalPrivacyInfoScroll');
        const intersectionTarget = document.querySelector('#fullModalPrivacyAccept');
        function handleIntersection(entries) {
            entries.map((entry) => {
                if (entry.isIntersecting) {
                    infoScroll.classList.remove('isVisible');
                } else {
                    infoScroll.classList.add('isVisible');
                }
            });
        }
        const buttonObserver = new IntersectionObserver(handleIntersection);
        buttonObserver.observe(intersectionTarget);
    }

    // Form Newsletter (separata perche' e' l'unica che puo' essere presente contemporaneamente ad un'altra)
    //
    // Logica di selezione: all'inizio il cb e' disabilitato e devo per forza aprire la modale e accettare da li'; dopodiche' posso agire direttamente sul cb
    //
    var privacyAcceptedNL = false;
    $('#privacyNL').click(function(e) {
        if (! privacyAcceptedNL) {
            e.preventDefault();
            $('[popovertarget="fullModalPrivacyNL"]:not([popovertargetaction])').click();
        }
    });
    $('#fullModalPrivacyAcceptNL').click(function(e) {
        e.preventDefault();
        privacyAcceptedNL = true;
        $('#privacyNL').prop('checked', true).change();
        $('[popovertarget="fullModalPrivacyNL"][popovertargetaction="hide"]').click();
    });
    //
    // Rimozione info scroll
    // 
    if ($('#fullModalPrivacyInfoScrollNL').length && $('#fullModalPrivacyAcceptNL').length) {
        var infoScrollNL = document.querySelector('#fullModalPrivacyInfoScrollNL');
        const intersectionTargetNL = document.querySelector('#fullModalPrivacyAcceptNL');
        function handleIntersectionNL(entries) {
            entries.map((entry) => {
                if (entry.isIntersecting) {
                    infoScrollNL.classList.remove('isVisible');
                } else {
                    infoScrollNL.classList.add('isVisible');
                }
            });
        }
        const buttonObserverNL = new IntersectionObserver(handleIntersectionNL);
        buttonObserverNL.observe(intersectionTargetNL);
    }

    //
    // Modali popup privacy forms - FINE
    //
 

  //Accordion
  
  $('accordion .js-content').hide();    
  $('.accordion__item .js-header').attr('aria-expanded','false');


  $('.accordion .accordion__item:first-child .js-header').toggleClass('active');
  $('.accordion .accordion__item:first-child .js-content').show();
  $('.accordion__item:first-child .js-header').attr('aria-expanded','true');



  //var $title = $('.accordion .js-header');

  $('.accordion .js-header').click(function () {
      $(this).next().slideToggle();
      $(this).toggleClass('active');


      // toggle attributi
      if($(this).attr('aria-expanded') == 'true'){
          $(this).attr('aria-expanded','false');
      }

      return false;

  });



});

// Observer on header
const header = document.querySelector("header");
const nav = document.querySelector(".checkScroll");

const navOptions = {
    root: null,
    threshold: 1,
    rootMargin: "0px 0px 0px 0px"
};

const navObserver = new IntersectionObserver(function(entries, navObserver) {
    entries.forEach(entry => {
        if (!entry.isIntersecting) {
            header.classList.add("headerScrolled");
        } else {
            header.classList.remove("headerScrolled");
        }
    });
}, navOptions);

navObserver.observe(nav);
